// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"934":"87fc0653","2079":"ed48bdc0"}[chunkId] + ".chunk.css";
};